import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import EventItem from './view';

export default connect(controller)(EventItem);
